import styled from "styled-components";

export const HelperButton = styled.div`
    border: 1px solid #48484a;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;
    margin-left: 5px;
    
    span {
        color: #48484a;
    }
`;

export const HelperContainer = styled.div`
   border: 1px solid #d2d3d5;
   z-index: 200;
   position: absolute;
   padding: 0px 10px;
   box-shadow: 0px 0px 15px 15px #d2d3d5;
   top: 160px;
   border-radius: 8px;
   display: flex;
   align-items: center;
   justify-content: center;
   background-color: #ffffff;
`;

export const HelperText = styled.p`
   color: #48484a;
   font-size: 14px;
`;